import { AxiosResponse } from "axios";

import { CustomEventType, dispatchCustomEvent } from "@/utils/custom-event";

export const handleUnauthenticated = () => {
  return async (response: AxiosResponse): Promise<AxiosResponse> => {
    if (response.status !== 401) {
      return Promise.resolve(response);
    }

    // Jotaiの状態が使えないのでカスタムイベントで伝播させて認証用コンポーネントで処理する
    dispatchCustomEvent(CustomEventType.ApiUnauthenticated);

    return Promise.resolve(response);
  };
};
